// Land/Sprache wechseln lädt die Seite neu: aktuelle Adresse (mit ?view=…) als Rücksprung, Scrollposition behalten.
(() => {
  const KEY = 'gusto39-loc-scroll';
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    sessionStorage.removeItem(KEY);
    if (saved && saved.path === location.pathname) {
      history.scrollRestoration = 'manual';
      const go = () => window.scrollTo(0, saved.y);
      go();
      window.addEventListener('load', go, { once: true });
    }
  } catch (e) {}
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.loc__panel');
    if (!form) return;
    const back = form.querySelector('[name="return_to"]');
    if (back) back.value = location.pathname + location.search;
    try { sessionStorage.setItem(KEY, JSON.stringify({ path: location.pathname, y: window.scrollY })); } catch (e) {}
  });
})();
